import type { IChartDataPoint } from './types';

export const CHART_BASE_DATA: IChartDataPoint[] = [
  { name: '22.03', default: 110 },
  { name: '22.03', default: 150, baseIncrease: 60 },
  { name: '22.03', default: 200, baseIncrease: 110 },
];

export const CHART_CONFIG = {
  width: 500,
  height: 220,
  yDomain: [0, 700] as [number, number],
  barSize: 125,
  increasePer100Limit: 30,
};
